import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
 

const AllServices = () => {
  const servicesData = [
  { 
    id: '01', 
    title: 'Web Design and Development', 
    path: '/web-design-and-development',
    description: 'We help you build successful web products by understanding your market and users.', 
    largeImage: '/images/web-design-development.jpg', 
    thumbImage: '/images/web-design-development-thumb.jpg' 
  },
  { 
    id: '02', 
    title: 'Mobile App Development', 
    path: '/mobile-app-development',
    description: 'Crafting intuitive, high-performance iOS and Android applications tailored for your business expansion.', 
    largeImage: '/images/mobile-app-development.jpg', 
    thumbImage: '/images/mobile-app-development-thumb.jpg' 
  },
  { 
    id: '03', 
    title: 'Digital Marketing', 
    path: '/digital-marketing',
    description: 'Driving growth and engagement through data-driven campaigns, SEO, and targeted strategic marketing.', 
    largeImage: '/images/digital-marketing.jpg', 
    thumbImage: '/images/digital-marketing-thumb.jpg' 
  },
  { 
    id: '04', 
    title: 'Power BI Services', 
    path: '/power-bi-services',
    description: 'Transforming raw organizational data into stunning, interactive dashboards and actionable analytics.', 
    largeImage: '/images/power-bi-services.jpg', 
    thumbImage: '/images/power-bi-services-thumb.jpg' 
  },
  { 
    id: '05', 
    title: 'ServiceNow Development', 
    path: '/servicenow-development',
    description: 'Optimizing digital workflows and IT service management architectures for enterprise efficiency.', 
    largeImage: '/images/servicenow-development.jpg', 
    thumbImage: '/images/servicenow-development-thumb.jpg' 
  },
  { 
    id: '06', 
    title: 'Infrastructure Development', 
    path: '/infrastructure-development',
    description: 'Building secure, scalable, and highly redundant cloud and physical hardware infrastructures.', 
    largeImage: '/images/infrastructure-development.jpg', 
    thumbImage: '/images/infrastructure-development-thumb.jpg' 
  },
  { 
    id: '07', 
    title: 'Application Development', 
    path: '/application-development',
    description: 'Custom software application design and engineering scaled precisely to modern enterprise requirements.', 
    largeImage: '/images/application-development.jpg', 
    thumbImage: '/images/application-development-thumb.jpg' 
  },
  { 
    id: '08', 
    title: 'Process Outsourcing', 
    path: '/process-outsourcing',
    description: 'Reliable business process outsourcing structures handling operations smoothly and seamlessly.', 
    largeImage: '/images/process-outsourcing.jpg', 
    thumbImage: '/images/process-outsourcing-thumb.jpg' 
  },
  { 
    id: '09', 
    title: 'Cloud Migration', 
    path: '/cloud-migration',
    description: 'Accelerate your cloud journey safely with our zero-downtime framework migration patterns.', 
    largeImage: '/images/cloud-migration.jpg', 
    thumbImage: '/images/cloud-migration-thumb.jpg' 
  },
  { 
    id: '10', 
    title: 'Data Integration', 
    path: '/data-integration',
    description: 'Consolidating disparate data silos into a unified stream for centralized analytical evaluation.', 
    largeImage: '/images/data-integration.jpg', 
    thumbImage: '/images/data-integration-thumb.jpg' 
  },
  { 
    id: '11', 
    title: 'Mainframe Computing', 
    path: '/mainframes-computing',
    description: 'Legacy architecture modernization and performance upkeep for high-volume transaction safety.', 
    largeImage: '/images/mainframe-computing.jpg', 
    thumbImage: '/images/mainframe-computing-thumb.jpg' 
  },
  { 
    id: '12', 
    title: ' ', 
    path: '/product-engineering',
    description: 'From blueprint mockups to full architectural market launch strategies for new-era products.', 
    largeImage: '/images/product-engineering.jpg', 
    thumbImage: '/images/product-engineering-thumb.jpg' 
  }
];

  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef(null);
  const cardRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth < 992 || !containerRef.current || !cardRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const cardHeight = cardRef.current.offsetHeight;
      const offsetTop = 40; 

      if (containerRect.top <= offsetTop) {
        if (containerRect.bottom - cardHeight <= offsetTop) {
          cardRef.current.style.position = 'absolute';
          cardRef.current.style.top = 'auto';
          cardRef.current.style.bottom = '0px';
          cardRef.current.style.width = '100%';
        } else {
          cardRef.current.style.position = 'fixed';
          cardRef.current.style.top = `${offsetTop}px`;
          cardRef.current.style.bottom = 'auto';
          cardRef.current.style.width = `${cardRef.current.parentElement.offsetWidth - 24}px`;
        }
      } else {
        cardRef.current.style.position = 'relative';
        cardRef.current.style.top = '0px';
        cardRef.current.style.bottom = 'auto';
        cardRef.current.style.width = '100%';
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <section className="services-section py-5 bg-black">
      <div className="container-fluid px-md-5">
        
        {/* Brand Header */}
        <div className="row mb-5">
          <div className="col-12 text-center">
            
             

            <h1 className="agency-headline text-white font-weight-bold text-uppercase m-0">
          <span className="line-one d-block">  Our  </span>
          
          <span className="line-two d-block">
            <span className="text-outline "> Operations</span>
            <span className="text-accent-solid text-lime">S</span>
            <span className="text-outline">ervices</span>
            {/* <span className="text-solid">   Solutions</span> */}
          </span>
                    
        </h1>
          </div>
        </div>

        {/* Main layout frame track */}
        <div ref={containerRef} className="row g-5 align-items-start position-relative">
          
          {/* Left Column: Side Sticky Viewport Showcase Panel */}
          <div className="col-lg-4 d-none d-lg-block js-sticky-parent">
            <div ref={cardRef} className="sticky-preview-card p-4 rounded-4 bg-bark shadow-sm " style={{height: 600}}>
              <div className="rounded-1  overflow-hidden mb-4">
                <img  
                  src={servicesData[activeIndex].largeImage} 
                  alt={servicesData[activeIndex].title} 
                  className="w-100 preview-img  " style={{height: 600}}
                />
              </div>
              
               

             
              {/* Dynamic Action Button linking directly to the highlighted active path */}
              <div className="px-2">
                <Link 
                  to={servicesData[activeIndex].path} 
                  className="btn btn-primary w-100 rounded-pill py-2.5 fw-semibold shadow-sm transition-all explore-service-btn"
                >
                  For More info :- {servicesData[activeIndex].title}
                </Link>
              </div>
            </div>
          </div>

          {/* Right Column: Interactive Catalog Rows */}
          <div className="col-lg-8">
            <div className="services-list-container">
              {servicesData.map((service, index) => {
                const isActive = index === activeIndex;
                return (
                  <div 
                    key={service.id}
                    className={`service-item-row py-4 border-bottom transition-all ${isActive ? 'active-row' : ''}`}
                    onMouseEnter={() => setActiveIndex(index)}
                  >
                    {/* Wrap text info details area in clickable routing link wrapper targeting its custom component subpath */}
                    <Link to={service.path} className="text-decoration-none plain-link-wrapper">
                      <div className="row align-items-center position-relative g-3">
                        
                        {/* Service ID Marker */}
                        <div className="col-auto col-md-1 text-center">
                          <span className={`index-number fw-bold fs-5 transition-all ${isActive ? 'text-danger' : 'text-muted opacity-50'}`}>
                            [{service.id}]
                          </span>
                        </div>

                        {/* Title & Description Text Blocks */}
                        <div className="col col-md-8 col-lg-7">
                          <h3 className={`service-title fw-bold m-0 transition-all ${isActive ? 'text-white fs-2' : 'text-white fs-4 opacity-50'}`}>
                            {service.title}
                          </h3>
                          {isActive && (
                            <p className="service-description mt-3 text-muted fs-6 lh-base animate-fade-in m-0">
                              {service.description}
                            </p>
                          )}
                        </div>

                        {/* Micro Image Thumb Displays */}
                        <div className="col-auto col-md-3 col-lg-4 ms-auto text-end d-sm-block d-none">
                          <div className={`thumb-wrapper rounded overflow-hidden shadow-sm d-inline-block transition-all ${isActive ? 'scale-110 active-thumb' : 'grayscale-blur'}`}>
                            <img 
                              src={service.thumbImage} 
                              alt={`${service.title} route asset thumb`} 
                              className="img-fluid thumb-img" 
                            />
                          </div>
                        </div>

                      </div>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AllServices;